/*
 * @@Description: 对外组件
 * @@Author: MuYang
 * @Date: 2021-07-28 10:57:30
 * @LastEditTime: 2021-10-12 15:36:30
 */
// import Vue from 'Vue'
import SyTable from './table.js'
import SyGroupTable from './group-table'
import SyTableColumn from './components/table-column'

// 全局指令
import ref from './vue-ref'
window.fe.vue.use(ref, { name: 'vue-ref' })

export { SyGroupTable, SyTableColumn }

export default SyTable
